import { createReducer } from '@common/utils/redux';

export type DatasheetTabPreferenceState = {
  byKey: Record<string, number | undefined>;
};

const initialState: DatasheetTabPreferenceState = {
  byKey: {},
};

const SET_TAB_PREFERENCE = 'datasheets/SET_TAB_PREFERENCE';
const CLEAR_TAB_PREFERENCES_BY_PREFIX = 'datasheets/CLEAR_TAB_PREFERENCES_BY_PREFIX';

export const setDatasheetTabPreference = (cacheKey: string, tabId: number | undefined) => ({
  type: SET_TAB_PREFERENCE,
  payload: { cacheKey, tabId },
});

/** Remove persisted tab keys used by pedigree split datasheet (see tab cache key in result main controller). */
export const clearDatasheetTabPreferencesByPrefix = (prefix: string) => ({
  type: CLEAR_TAB_PREFERENCES_BY_PREFIX,
  payload: { prefix },
});

export const datasheetTabPreferenceReducer = createReducer(initialState, {
  [SET_TAB_PREFERENCE]: (
    state: DatasheetTabPreferenceState,
    payload: { cacheKey: string; tabId: number | undefined }
  ) => ({
    ...state,
    byKey: {
      ...state.byKey,
      [payload.cacheKey]: payload.tabId,
    },
  }),
  [CLEAR_TAB_PREFERENCES_BY_PREFIX]: (
    state: DatasheetTabPreferenceState,
    payload: { prefix: string }
  ) => {
    const next = { ...state.byKey };
    for (const key of Object.keys(next)) {
      if (key.startsWith(payload.prefix)) {
        delete next[key];
      }
    }
    return { ...state, byKey: next };
  },
});

export const selectDatasheetTabPreference = (
  state: { datasheetTabPreference?: DatasheetTabPreferenceState },
  cacheKey: string
): number | undefined => state.datasheetTabPreference?.byKey?.[cacheKey];
